module.exports = __webpack_public_path__ + "img/07-02_Advancing My Career.36472666.svg";